import { createEvent } from '@cobuildlab/react-simple-state';
import { PlanStripeCouponType } from '../plan-types';

export const createSharedCouponEvent = createEvent<void>();
export const createSharedCouponEventError = createEvent<Error>();

export const editCouponEvent = createEvent<PlanStripeCouponType>();
export const editCouponEventError = createEvent<Error>();

export const enableOrDisableStripeCouponEvent = createEvent<PlanStripeCouponType>();
export const enableOrDisableStripeCouponEventError = createEvent<Error>();
